class statisticsOpenedInvListCtrl {
  constructor(
    $scope,
    logger,
    httpRequest,
    $state,
    treeSelectService,
    initSortService
  ) {
    // 下拉销方
    $scope.querySaleConfig = {
      queryName: 'saleName',
      queryKey: 'saleId',
      queryType: 'Flater',
      parentIdName: 'parentSaleId',
      multiple: true,
      parentId: 0,
      defaultSelect: [],
    }
    $scope.queryOrgConfig = {
      queryName: 'orgName',
      queryKey: 'orgId',
      queryType: 'statistTree',
      parentIdName: 'parentOrgId',
      multiple: true,
      parentId: $scope.pageState.userInfo.org.parentOrgId,
      defaultSelect: [],
    }
    $scope.queryUkeyConfig = {
      queryName: 'ukeyName',
      queryKey: 'ukeyId',
      queryType: 'Flater',
      parentIdName: 'parentUkeyId',
      multiple: true,
      parentId: 0,
      defaultSelect: [],
    }
    $scope.param = {
      pageNum: 1,
      pageSize: 10,
      param: {
        applyDateMax: '',
        applyDateMin: '',
        custCodeName: '',
        invType: '',
        invoiceCodeNumber: '',
        invoiceDateMax: initDate(),
        invoiceDateMin: initDate(1),
        invoiceStatus: '',
        isList: '',
        isRed: '',
        matName: '',
        openPeople: '',
        orgIdList: [],
        saleIdList: [],
        taxRate: '',
        ukeyIdList: [],
        billCode: '',
        billBatchNo: '',
        invoiceCode: '',
        invoiceNumber: '',
        accessToken: $scope.pageState.idToken,
      },
    }
    $scope.reset = function () {
      $scope.param.param = {
        applyDateMax: '',
        applyDateMin: '',
        custCodeName: '',
        invType: '',
        invoiceCodeNumber: '',
        invoiceDateMax: initDate(),
        invoiceDateMin: initDate(1),
        invoiceStatus: '',
        isList: '',
        isRed: '',
        matName: '',
        openPeople: '',
        orgIdList: [],
        saleIdList: [],
        taxRate: '',
        ukeyIdList: [],
        billCode: '',
        billBatchNo: '',
        invoiceCode: '',
        invoiceNumber: '',
        accessToken: $scope.pageState.idToken,
      }
      $scope.querySaleConfig.defaultSelect = []
      $scope.queryOrgConfig.defaultSelect = defaultOrg
      $scope.queryUkeyConfig.defaultSelect = []
    }
    // $scope.reset()
    // 查询展开
    $scope.isFilterCollapsed = false
    $scope.customizedConfig = {
      version: 1.33,
      table: [
        {
          label: '发票种类',
          selected: true,
          default: true,
        },
        {
          label: '发票性质',
          selected: true,
          default: true,
        },
        {
          label: '发票代码',
          selected: true,
          default: true,
        },
        {
          label: '发票号码',
          selected: true,
          default: true,
        },
        {
          label: '销方名称/信用代码',
          selected: true,
          default: true,
        },
        {
          label: '开票机构',
          selected: true,
          default: true,
        },
        {
          label: '合计金额/税额',
          selected: true,
          default: true,
        },
        {
          label: '发票状态',
          selected: true,
          default: true,
        },
        {
          label: '开票点',
          selected: false,
          default: false,
        },
        {
          label: '价税合计',
          selected: false,
          default: false,
        },
        {
          label: '备注',
          selected: false,
          default: false,
        },
        {
          label: '购方名称',
          selected: false,
          default: false,
        },
        {
          label: '购方信用代码',
          selected: false,
          default: false,
        },
        {
          label: '购方地址电话',
          selected: false,
          default: false,
        },
        {
          label: '购方开户行及账号',
          selected: false,
          default: false,
        },
        {
          label: '开票人',
          selected: false,
          default: false,
        },
        {
          label: '开票日期',
          selected: false,
          default: false,
        },
        {
          label: '单据编号',
          selected: true,
          default: true,
        },
        {
          label: '关联销售单',
          selected: false,
          default: false,
        },
        {
          label: '主商品名称',
          selected: false,
          default: false,
        },
        {
          label: '税率',
          selected: false,
          default: false,
        },
        {
          label: '清单标志',
          selected: false,
          default: false,
        },
        {
          label: '收款人',
          selected: false,
          default: false,
        },
        {
          label: '复核人',
          selected: false,
          default: false,
        },
        {
          label: '申请日期',
          selected: false,
          default: false,
        },
        {
            label: '全电发票号码',
            selected: true,
            default: true,
        },
        {
            label: '发票来源',
            selected: true,
            default: true,
        },
        {
            label: '特定业务类型',
            selected: true,
            default: true,
        },
      ],
      queryConfig: [
        {
          label: '开票日期',
          default: true,
          selected: true,
        },
        {
          label: '购方名称/信用代码',
          default: true,
          selected: true,
        },
        {
          label: '发票种类',
          default: true,
          selected: true,
        },
        {
          label: '开票机构',
          default: true,
          selected: true,
        },
        {
          label: '销方名称',
          default: false,
          selected: false,
        },
        {
          label: '开票点',
          default: false,
          selected: false,
        },
        {
          label: '申请日期',
          default: false,
          selected: false,
        },
        {
          label: '清单标志',
          default: false,
          selected: false,
        },
        {
          label: '开票人',
          default: false,
          selected: false,
        },
        {
          label: '单据编号',
          default: false,
          selected: false,
        },
        {
          label: '发票性质',
          default: false,
          selected: false,
        },
        {
          label: '发票状态',
          default: false,
          selected: false,
        },
        {
          label: '发票代码',
          default: false,
          selected: false,
        },
        {
          label: '发票号码',
          default: false,
          selected: false,
        },
        {
            label: '全电发票号码',
            selected: true,
            default: true,
        },
        {
            label: '发票来源',
            selected: true,
            default: true,
        },
        {
            label: '特定业务类型',
            selected: true,
            default: true,
        },
      ],
    }

    // 表头排序
    $scope.orderMap = initSortService('openedInvParam')
    $scope.selectedHandle = function selectedHandle() {
      $scope.param.orderMap = {}
      if ($scope.orderMap.sortKey)
        $scope.param.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
      sessionStorage.setItem('openedInvParam', JSON.stringify($scope.param))
      queryInfo()
    }

    // 时间格式初始化
    function initDate(day, month, year) {
      const date = new Date()
      const y = year || date.getFullYear()
      let m = month || date.getMonth() + 1
      let d = day || date.getDate()
      m = m < 10 ? `0${m}` : m
      d = d < 10 ? `0${d}` : d
      return `${y}-${m}-${d}`
    }

    // 默认值
    $scope.param.param.orgIdList[0] =
      $scope.pageState.userInfo.user.currentOrgId // 默认选当前机构
    $scope.orgList = [] // 机构
    $scope.ukeyList = [] // 开票点
    $scope.saleList = [] // 销方
    // 下拉机构组件配置

    // 机构变化
    $scope.orgSelectChange = function (v) {
      const orgSelectArr = v
      const orgSelectL = orgSelectArr.length
      if (orgSelectL > 0) {
        $scope.param.param.orgIdList = orgSelectArr.map((item) => item.orgId)
      } else {
        $scope.param.param.orgIdList = []
      }
      $scope.param.param.ukeyIdList = []
      $scope.queryUkeyConfig.defaultSelect = []
      $scope.queryOrgConfig.defaultSelect = v
      httpRequest
        .post_qryUkeyListOfOrgIds($scope.param.param.orgIdList)
        .then((res) => {
          if (res.data.success) {
            $scope.ukeyList = treeSelectService(
              res.data.value,
              'ukeyId',
              'ukeyName'
            )
          }
        })
    }
    // 下拉开票点

    // 开票点变化
    $scope.ukeySelectChange = function (v) {
      const ukeySelectArr = v
      const ukeySelectL = ukeySelectArr.length
      if (ukeySelectL > 0) {
        $scope.param.param.ukeyIdList = ukeySelectArr.map((item) => item.ukeyId)
      } else {
        $scope.param.param.ukeyIdList = []
      }
    }

    // 销方变化
    $scope.saleSelectChange = function (v) {
      const saleSelectArr = v
      const saleSelectL = saleSelectArr.length
      if (saleSelectL > 0) {
        $scope.param.param.saleIdList = saleSelectArr.map((item) => item.saleId)
      } else {
        $scope.param.param.saleIdList = []
      }
    }
    let defaultOrg = []
    httpRequest.get_getUserOrgList().then((res) => {
      if (res.data.success) {
        $scope.orgList = JSON.parse(JSON.stringify(res.data.value))
        $scope.queryOrgConfig.defaultSelect = res.data.value.filter(
          (item) => item.orgId === $scope.pageState.userInfo.user.currentOrgId
        )
        defaultOrg = res.data.value.filter(
          (item) => item.orgId === $scope.pageState.userInfo.user.currentOrgId
        )
        // 返回机构名称
        $scope.fliterOrgName = function (id) {
          if (id === null) {
            return id
          }
          if (res.data.value === null) {
            return id
          }
          const fliterUkeyNameArr = res.data.value.filter(
            (item) => item.orgId === id
          )
          if (fliterUkeyNameArr.length > 0) {
            return fliterUkeyNameArr[0].orgName
          }
          return id
        }
        // 默认取当前机构所有子机构的开票点和销方
        // 返回开票点数组

        const _orgIdList = res.data.value.map((item) => item.orgId)
        httpRequest
          .post_qryUkeyListOfOrgIds($scope.param.param.orgIdList)
          .then((res) => {
            if (res.data.success) {
              $scope.ukeyList = treeSelectService(
                res.data.value,
                'ukeyId',
                'ukeyName'
              )
              queryInfo()
            }
          })
        // 销方
        if (_orgIdList.length > 0) {
          httpRequest.post_getSaleInfoListByOrgIds(_orgIdList).then((res) => {
            $scope.saleList = treeSelectService(res.data, 'saleId', 'saleName')
          })
        }
      }
    })

    // 导出
    $scope.exportInvoic = function () {
      const params = $.extend({}, $scope.param.param)
      for (let i in $scope.param.orderMap) {
        params.sortField = i + ':' + $scope.param.orderMap[i]
      }
    //   httpRequest.get_exportOpenedOvatInvoiceToXLS(params)
      httpRequest.get_exportOpenedOvatInvoiceTax4ToXLS(params)
    }

    $scope.currentPage = 1 // 设置显示第一页
    $scope.maxSize = 10 // 每一叶显示记录数

    $scope.pageChanged = function () {
      // 点击页码发起查询
      sessionStorage.setItem(
        'openedInvParam',
        JSON.stringify({
          orderMap: $scope.param.orderMap,
          pageNum: $scope.param.pageNum,
          pageSize: $scope.param.pageSize,
          param: sessionStorage.openedInvParam
            ? JSON.parse(sessionStorage.openedInvParam).param
            : {
                applyDateMax: '',
                applyDateMin: '',
                custCodeName: '',
                invType: '',
                invoiceCodeNumber: '',
                invoiceDateMax: initDate(),
                invoiceDateMin: initDate(1),
                invoiceStatus: '',
                isList: '',
                isRed: '',
                matName: '',
                openPeople: '',
                orgIdList: [],
                saleIdList: [],
                taxRate: '',
                ukeyIdList: [],
                billCode: '',
                billBatchNo: '',
                invoiceCode: '',
                invoiceNumber: '',
                accessToken: $scope.pageState.idToken,
              },
        })
      )
      queryInfo()
    }
    // let isSearch = false
    // $scope.$watch('param', () => {
    //     isSearch = false
    // }, true)
    // $scope.$on('$stateChangeStart', (e, toState) => {
    //     if (toState.name.indexOf('statistics.outputStatistics.statisticsOpenedInv') != -1) {
    //         isSearch && sessionStorage.setItem('openedInvParam', JSON.stringify($scope.param))
    //     }
    // })
    function queryInfo() {
      const invoiceDateMaxTmp = new Date($scope.param.param.invoiceDateMax)
      const invoiceDateMinTmp = new Date($scope.param.param.invoiceDateMin)
      if (overOneYear(invoiceDateMaxTmp, invoiceDateMinTmp)) {
        $scope.listData = []
        logger.logError('[开票日期]起始结束时间跨度不能超过一年')
        return
      }
      $scope.param = sessionStorage.openedInvParam
        ? JSON.parse(sessionStorage.openedInvParam)
        : $scope.param
      httpRequest.post_qryOpenedOvatInvoiceTax4List($scope.param).then((res) => {
        $scope.listData = res.data.value.list

        // 获取后台分页数据 回写分页组件
        $scope.totalItems = res.data.value.total
        $scope.param.pageNum = res.data.value.pageNum
      })
    }

    function overOneYear(max, min) {
      const dateMaxTmp = new Date(max)
      const dateMinTmp = new Date(min)

      const dateMaxYear = dateMaxTmp.getFullYear()
      const dateMaxMonth = dateMaxTmp.getMonth()
      const dateMaxDay = dateMaxTmp.getDate()

      const dateMinYear = dateMinTmp.getFullYear()
      const dateMinMonth = dateMinTmp.getMonth()
      const dateMinDay = dateMinTmp.getDate()

      return (
        dateMaxYear - dateMinYear > 1 ||
        (dateMaxYear - dateMinYear === 1 && dateMaxMonth - dateMinMonth > 0) ||
        (dateMaxYear - dateMinYear > 0 &&
          dateMaxMonth - dateMinMonth === 0 &&
          dateMaxDay - dateMinDay > -1)
      )
    }

    $scope.toDetailPage = function (item) {
      const url = $state.href(
        'outputManage.billManage.openedInvoice.detail',
        {
          invoiceId: item.invoiceId,
        },
        {
          reload: true,
        }
      )
      window.open(url, '_blank')
    }

    // 查看关联销售单
    $scope.relatedBill = function (item) {
      if (item.billCount === 0) {
        return
      }
      if (item.waitId === undefined) {
        return
      }
      $state.go('statistics.outputStatistics.statisticsOpenedInv.relatedBill', {
        waitId: item.waitId,
      })
    }

    $scope.searchlist = function () {
      // 点击搜索发起查询
      sessionStorage.setItem('openedInvParam', JSON.stringify($scope.param))
      queryInfo()
    }
    $scope.searchKeyUpEnter = function (e) {
      const keycode = window.event ? e.keyCode : e.which // 获取按键编码
      if (keycode == 13) {
        queryInfo()
      }
    }
  }
}
statisticsOpenedInvListCtrl.$inject = [
  '$scope',
  'logger',
  'httpRequest',
  '$state',
  'treeSelectService',
  'initSortService',
]
export default statisticsOpenedInvListCtrl



// WEBPACK FOOTER //
// ./src/app/statistics/outputStatistics/statisticsOpenedInv/statisticsOpenedInvListCtrl.js